import { render, staticRenderFns } from "./TransactionDetailCard.vue?vue&type=template&id=efadf8e0&scoped=true&"
import script from "./TransactionDetailCard.vue?vue&type=script&lang=js&"
export * from "./TransactionDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDetailCard.vue?vue&type=style&index=0&id=efadf8e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efadf8e0",
  null
  
)

export default component.exports